import "@hakili/ui/styles.css";

import { createRoot } from "react-dom/client";

import { App } from "./App.js";

/**
 * The entry point of `expert-web`, `P0-UIK-020`; the body is `round C5.0`'s.
 *
 * The page is the one behind the tour sheet's link, so the route is the
 * document's own path and nothing more , no router, no session gate: the
 * cabinet has no account at stage 1 (WF-CON-32 step 1), and the link is what
 * it holds.
 */
const racine = document.querySelector("#racine");
if (racine === null) {
  // Not a silent no-op: a missing mount point means the entry document and the
  // entry script disagree, and the page would be blank with nothing in the
  // console to say why.
  throw new Error("racine introuvable");
}

createRoot(racine).render(
  <App origin={import.meta.env.VITE_API_ORIGIN} pathname={window.location.pathname} />,
);
